import { useSyncExternalStore } from 'react'
import { AvailableLocale } from '@/config/constants'
import intl from '@/lib/intl'

const subscribe = (onChange: () => void) => intl.onLocaleChange(onChange)
const getSnapshot = () => intl.locale as AvailableLocale

const useLocale = (): AvailableLocale => {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}

export default useLocale
